import React from 'react';
import { Box } from '@mui/material';
import { minLength, required } from 'react-admin';

import SmartDateTimeInput from '../../../../customFields/SmartDateTimeInput';
import SelectArrayInput from '../../../layout/inputFields/SelectArrayInput';
import caseStatuses, { caseStatusLabels } from '../../../../constants/caseStatuses';
import isPastDate from '../../../utils/reports/isPastDate';
import dateRangeValidation from '../../../utils/reports/dateRangeValidation';
import dateParse, { dateFormat } from '../../../utils/dateParser';
import FieldBox from '../FieldBox';
import RangeFields from '../RangeFields';

const CaseStatusHistory = (): React.ReactElement => (
  <Box display="flex" flexDirection="column" gap={4}>
    <FieldBox title="Date range" description="Include status updates within this date/time range (Europe/Stockholm timezone). From defaults to 2000-01-01 00:00; To defaults to generation time and includes the entire selected minute.">
      <RangeFields
        from={(
          <SmartDateTimeInput
            fullWidth
            source="report.from"
            label="From"
            validate={[isPastDate, dateRangeValidation]}
            parse={dateParse}
            format={dateFormat}
            helperText={false}
          />
        )}
        to={(
          <SmartDateTimeInput
            fullWidth
            source="report.to"
            label="To"
            validate={[dateRangeValidation]}
            parse={dateParse}
            format={dateFormat}
            helperText={false}
          />
        )}
      />
    </FieldBox>
    <FieldBox title="Statuses" description="Include updates to these statuses, regardless of the current case status. Select at least one status.">
      <SelectArrayInput
        fullWidth
        label=""
        source="report.statuses"
        choices={[
          caseStatuses.OPEN,
          caseStatuses.IN_PROGRESS,
          caseStatuses.PENDING,
          caseStatuses.CLOSED,
        ].map((status) => ({ id: status, name: caseStatusLabels[status] }))}
        validate={[required(), minLength(1)]}
        helperText={false}
      />
    </FieldBox>
  </Box>
);

export default CaseStatusHistory;
